import { FreeShippingPrice } from "~/loaders/freeShippingPrice"
import FreeShipping from "~/components/free-shipping/index"

export interface FreeShippingSectionProps {
    /**
     * @title Valor para frete grátis
     */
    freeShippingValue: FreeShippingPrice
    /**
     * @title Layout
     */
    layout?: 'header' | 'cart'
}

const FreeShippingSection = (props: FreeShippingSectionProps) => {
    return (
        <>
            <FreeShipping {...props} />
        </>
    )
}

export default FreeShippingSection

export function LoadingFallback() {
    return (
        <div
            className='w-full bg-bege animate-pulse'
            style={{
                height: '35px',
            }}
        />
    )
}
